import { render, staticRenderFns } from "./tab-pane.vue?vue&type=template&id=37f4256e&"
import script from "./tab-pane.vue?vue&type=script&lang=js&"
export * from "./tab-pane.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yoreirei/Documents/project/other/market-ui/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37f4256e')) {
      api.createRecord('37f4256e', component.options)
    } else {
      api.reload('37f4256e', component.options)
    }
    module.hot.accept("./tab-pane.vue?vue&type=template&id=37f4256e&", function () {
      api.rerender('37f4256e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lib/tabs/src/tab-pane.vue"
export default component.exports